// Utils
import isProductAvailable from '../../../utils/isProductAvailable';

const splitOrderItems = (orderItems = [], productsObj = {}) => {
  const sharedKitOnly = [];
  const unavailable = [];
  const available = [];

  orderItems.forEach((item) => {
    const product = productsObj?.[item.product];

    if (item.from_shared_kit && !product?.is_available_for_user) {
      sharedKitOnly.push(item);
      return;
    }

    if (product && !isProductAvailable(product)) {
      unavailable.push(item);
      return;
    }

    available.push(item);
  });

  return { sharedKitOnly, unavailable, available };
};

export { splitOrderItems };
